<template>
    <Fragment>
        <div class="card mb-3">
            <div class="card-header">
                <div class="d-flex flex-row" style="width: 100%">
                    <p class="mr-auto">
                        <span class="bold">{{
                            $t("config_manag_table_header_name")
                        }}</span>
                        :
                        <span v-show="configuration.isEditing == true">
                            <input
                                v-model="configuration.label"
                                class="form-control d-inline"
                                style="width: auto"
                            />
                        </span>
                        <span v-show="!configuration.isEditing">
                            {{ configuration.label }}
                        </span>
                    </p>

                    <configuration-actions-component
                        :editActions="true"
                        :configuration="configuration"
                    ></configuration-actions-component>
                </div>

                <!-- DRAFT TOTS ELS CAMPS -->
                <div class="d-block">
                    <p class="text-left">
                        <span class="bold">{{
                            $t("config_manag_table_header_date")
                        }}</span>
                        : {{ configuration.updated_at_formatted }}
                    </p>
                    <p class="text-left">
                        <span class="bold">{{ $t("project") }}</span>
                        :
                        <!-- DROPDOWN EXISTING PROJECTS -->
                        <select
                            id="projectSelect"
                            class="custom-select" style="width:auto"
                            :disabled="!configuration.isEditing"
                            v-model="configuration.project_id"
                        >
                            <option selected :value="null">
                                {{ $t("projects_no_project") }}
                            </option>
                            <option
                                v-for="(project, index) in app.projects.list"
                                :key="index"
                                :value="project.id"
                            >
                                {{ project.label }}
                            </option>
                        </select>
                    </p>
                </div>
            </div>
        </div>

        <!-- DETAILS -->
        <saved-config-details-component
            :configuration="configuration.data"
        ></saved-config-details-component>
    </Fragment>
</template>

<script>
import { app } from "../../application.js";
import { Fragment } from "vue-fragment";
import configurationActionsComponent from "./configurationActions.vue"
import savedConfigDetailsComponent from "./savedConfigDetails.vue"

export default {
    name: 'configurationComponent',
    props: {
        configuration: Object,
        isEditing: false
    },

    components: {
        Fragment,
        configurationActionsComponent,
        savedConfigDetailsComponent
    },
    data() {
        return {
            app: app,
        }
    },
    watch: {
        async configuration(){
             await this.app.projects.refresh()
        }
    },
    methods: {
    }
}
</script>

<style>
</style>